import { NotificationType } from "../../../../shared/types/NotificationTypes"
import { OrganizerType } from "../../../../shared/types/OrganizerTypes"

export type ServiceCenterBooking = Readonly<{
    id: number
    meetingDetails: ServiceCenterBookingMeetingDetails
    organizers: Array<ServiceCenterBookingOrganizer>
}>

export type ServiceCenterBookingMeetingDetails = Readonly<{
    location?: string
    meetingName: string
    startDateTime: string
    endDateTime: string
}>

export type ServiceCenterBookingOrganizer = Readonly<{
    type: OrganizerType
    name: string
    email: string
    mobilePhone?: string
    businessPhone?: string
    department?: {
        name: string
    }
    company?: {
        id: number
        name: string
    }
}>

export enum ServiceCenterGuestState {
    PENDING = "PENDING",
    ARRIVED = "ARRIVED",
    CANCELLED = "CANCELLED",
}

export type ServiceCenterGuestNotification = Readonly<{
    type: NotificationType
    notified: boolean
    time: string
}>

export type ServiceCenterGuest = Readonly<{
    id: number
    state: ServiceCenterGuestState
    timeline: {
        created: string
        expectedDate: string
        arrivalTime: string
    }
    guest: {
        name: string
        email: string
    }
    host: {
        id: number
        name: string
        company: string
    }
    notifications: Array<ServiceCenterGuestNotification>
}>

export type ServiceCenterNews = Readonly<{
    id: number
    uid: string
    subject: string
    shortDescription: string
    imageUrl: string
    body: string
    publishDate: string
    displayPublishDate: string
    created: string
    updated: string
    category: string
    creator: string
    createdByCompany: string
    permaLink: string
}>

export type AttendeeType = {
    type: "ATTENDEE"
    attendee: {
        id: number
    }
    guest?: {
        company: string
        name: string
    }
}

type Host = {
    id: number
}

export type GroupType = {
    type: "GROUP"
    host: Host
    group: {
        company: string
        count: number
    }
}

export type SingleType = {
    type: "SINGLE"
    host: Host
    guest: {
        company: string
        name: string
    }
}

export type CheckInData = AttendeeType | GroupType | SingleType

// Resources

export interface Resource {
    id: number
    reference: string
    name: string
    type: string
    status: string
    image?: Image
    buffer: number
    colorCode: string
    room?: RoomDetails
}

export interface Image {
    url: string
}

export interface RoomDetails {
    floor: Floor
    seats: number
    avEquipments: AVEquipment[]
    tableSetups: TableSetup[]
    meetingUsage: MeetingUsage
}

export interface Floor {
    name: string
    value: number
}

export interface AVEquipment {
    id: number
    name: string
}

export interface TableSetup {
    key: string
    name: string
    imageUrl: string
}

export interface MeetingUsage {
    internal: boolean
    external: boolean
}
